import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import store from '../store';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import ThemeCustomization from 'themes';
import Locales from 'components/Locales';
import ScrollTop from 'components/ScrollTop';
import { createReduxHistory } from '../history';
import { SnackbarProvider } from '../utils/snackbar/SnackbarContext';

const history = createReduxHistory(store);

const AppProviders = ({ children }) => {
    return (
        <ReduxProvider store={store}>
            <Router history={history}>
                <ThemeCustomization>
                    <Locales>
                        <ScrollTop>
                            <SnackbarProvider>{children}</SnackbarProvider>
                        </ScrollTop>
                    </Locales>
                </ThemeCustomization>
            </Router>
        </ReduxProvider>
    );
};

export default AppProviders;
